var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { transformComponent } from '../__builtins__/shared';
import { observer } from '@formily/reactive-vue';
import { connect, mapProps, mapReadPretty, h } from '@formily/vue';
import { defineComponent } from '@vue/composition-api';
import { Uploader as VanUploader } from 'vant';
import { PreviewText } from '../preview-text';
var TransformVanUploader = transformComponent(VanUploader, {
    change: 'input',
});
var BaseUploader = observer(defineComponent({
    name: 'FBaseUploader',
    setup: function (props, _a) {
        var attrs = _a.attrs, slots = _a.slots, listeners = _a.listeners;
        return function () {
            return h(TransformVanUploader, {
                attrs: __assign(__assign({}, attrs), { fileList: attrs.value }),
                on: listeners,
            }, slots);
        };
    },
}));
export var Uploader = connect(BaseUploader, mapProps({ readOnly: 'readonly' }), mapReadPretty(PreviewText.Uploader));
export default Uploader;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vant/esm/uploader/index.js
// module id = null
// module chunks = 